function handleMenus() {
    const menuToggle = document.getElementById('menu-open');

    if (menuToggle) {
        menuToggle.addEventListener('change', () => {
            const htmlElement = document.querySelector('html');

            if (htmlElement) {
                if (menuToggle.checked) {
                    htmlElement.classList.add('menu-open');
                }
                else {
                    htmlElement.classList.remove('menu-open');
                }
            }
        });
    }
}

function handleSubmenus() {
    const submenuContainers = document.querySelectorAll('.menu .has-submenu');

    submenuContainers.forEach((submenuContainer) => {
        const submenuToggle = submenuContainer.querySelector('input[type="checkbox"]');

        if (submenuToggle) {
            submenuToggle.addEventListener('change', () => {
                if (submenuToggle.checked) {
                    submenuContainer.classList.add('submenu-open');

                    submenuContainers.forEach((submenuContainer2) => {
                        const submenuToggle2 = submenuContainer2.querySelector('input[type="checkbox"]');

                        if (submenuToggle.id !== submenuToggle2.id) {
                            submenuToggle2.checked = false;
                        }
                    });
                }
                else {
                    submenuContainer.classList.remove('submenu-open');
                }
            });
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    handleMenus();
    handleSubmenus();
});
